import Page from './PrizeBannerPage'

export default Page;